import { docsActions } from "_actions/docs.actions";
import { documentTypes } from "_constants";
import _ from "lodash";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import { toast } from "react-toastify";
import { HsqSignaturePad } from "./HsqSignaturePad";
import "./Hsq.scss";

const SLUG = "hsq";

const HSQ_DEFAULTS = {
  wcft_level: "arduous",
  test_to_be_taken: "arduous_pack_test",
};

class Hsq extends Component {
  constructor(props) {
    super(props);
    this.state = {
      doc: null,
      form: {
        wcft_level: HSQ_DEFAULTS.wcft_level,
        hsq_question1: "",
        hsq_question2: "",
        hsq_question3: "",
        hsq_question4: "",
        hsq_question5: "",
        hsq_question6: "",
        hsq_question7: "",
        hsq_question8: "",
        hsq_question9: "",
        hsq_question10: "",
        applicant_signature: null,
        applicant_printed_name: "",
        applicant_date: moment().format("MM/DD/YYYY"),
        consent_read_brochure: "",
        consent_read_hsq: "",
        test_to_be_taken: HSQ_DEFAULTS.test_to_be_taken,
        consent_signature: null,
        consent_printed_name: "",
        consent_date: moment().format("MM/DD/YYYY"),
      },
      errors: {},
    };
    this.submitForm = this.submitForm.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);
    this.handleSignature = this.handleSignature.bind(this);
    this.getFormData = this.getFormData.bind(this);
    this.initDocAndLoadForm = this.initDocAndLoadForm.bind(this);
    this._loadedFormDocId = null;
  }

  applyHsqDefaults(form) {
    const wcftLevel = ["arduous", "moderate", "light"].includes(form.wcft_level)
      ? form.wcft_level
      : HSQ_DEFAULTS.wcft_level;
    const testToBeTaken = [
      "arduous_pack_test",
      "moderate_field_test",
      "light_walk_test",
    ].includes(form.test_to_be_taken)
      ? form.test_to_be_taken
      : HSQ_DEFAULTS.test_to_be_taken;

    return {
      ...form,
      wcft_level: wcftLevel || HSQ_DEFAULTS.wcft_level,
      test_to_be_taken: testToBeTaken || HSQ_DEFAULTS.test_to_be_taken,
    };
  }

  getEmployeeDisplayName(userFromApi) {
    const user =
      userFromApi ||
      this.props.user?.items?.data ||
      this.props.user?.profile?.data;
    if (!user) return "";
    if (user.full_name?.trim()) return user.full_name.trim();
    return [user.first_name, user.last_name].filter(Boolean).join(" ").trim();
  }

  applyPrintedNameDefaults(form, userFromApi) {
    const printedName = this.getEmployeeDisplayName(userFromApi);
    const withNames = printedName
      ? {
        ...form,
        applicant_printed_name: form.applicant_printed_name?.trim()
          ? form.applicant_printed_name
          : printedName,
        consent_printed_name: form.consent_printed_name?.trim()
          ? form.consent_printed_name
          : printedName,
      }
      : form;
    return this.applyHsqDefaults(withNames);
  }

  initDocAndLoadForm() {
    const docSlug = this.props.slug || SLUG;
    const allowedCategories = [documentTypes.Other];
    const { single_doc, new_doc_id } = this.props;

    let doc = this.props.docs.userDocs.find(
      (d) => d.slug === docSlug && allowedCategories.includes(d.docs_categories_id),
    );

    if (single_doc && new_doc_id) {
      const instanceDoc = this.props.docs.userDocs.find(
        (d) => String(d.id) === String(new_doc_id),
      );
      if (instanceDoc) {
        doc = instanceDoc;
      } else if (doc) {
        doc = { ...doc, id: new_doc_id };
      } else {
        doc = {
          slug: docSlug,
          id: new_doc_id,
          docs_categories_id: documentTypes.Other,
        };
      }
    }

    const docId = single_doc && new_doc_id ? new_doc_id : doc?.id;

    if (doc) {
      this.setState({ doc });
    }

    if (docId && docId !== this._loadedFormDocId) {
      this._loadedFormDocId = docId;
      this.getFormData(docId);
      return;
    }

    if (!docId) {
      this.setState((prev) => ({
        form: this.applyPrintedNameDefaults(prev.form),
      }));
    }
  }

  componentDidMount() {
    this.initDocAndLoadForm();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.new_doc_id !== this.props.new_doc_id ||
      prevProps.docs.userDocs !== this.props.docs.userDocs
    ) {
      this.initDocAndLoadForm();
    }
  }

  getFormData(id) {
    this.props.dispatch(docsActions.getForm(id)).then((res) => {
      if (res.success) {
        const incoming = res.data?.form || {};
        const user = res.data?.user;
        this.setState((prev) => ({
          form: this.applyPrintedNameDefaults(
            {
              ...prev.form,
              ...incoming,
              applicant_date: incoming.applicant_date || prev.form.applicant_date,
              consent_date: incoming.consent_date || prev.form.consent_date,
            },
            user,
          ),
        }));
      }
    });
  }

  handleFormChange(e) {
    const field = e.target.getAttribute("field") || e.target.name;
    if (!field) return;
    const { value, checked, type, disabled } = e.target;
    if (disabled) return;
    // WCFT level and test selection are fixed like the job application form.
    if (field === "form.wcft_level" && value !== HSQ_DEFAULTS.wcft_level) return;
    if (field === "form.test_to_be_taken") return;
    const nextState = { ...this.state };
    _.set(nextState, field, type === "checkbox" ? (checked ? "yes" : "") : value);
    this.setState({ ...nextState, errors: { ...this.state.errors, [field]: "" } });
  }

  handleSignature(field, signature) {
    const nextState = { ...this.state };
    _.set(nextState, field, signature);
    this.setState({ ...nextState, errors: { ...this.state.errors, [field]: "" } });
  }

  validate() {
    const { form } = this.state;
    const errors = {};
    for (let n = 1; n <= 10; n++) {
      if (!form[`hsq_question${n}`]) {
        errors[`hsq_question${n}`] = "Please select Yes or No.";
      }
    }
    if (!form.applicant_signature) errors.applicant_signature = "Applicant signature is required.";
    if (!form.applicant_printed_name.trim()) errors.applicant_printed_name = "Printed name is required.";
    if (form.consent_read_brochure !== "yes") errors.consent_read_brochure = "You must acknowledge reading the WCT brochure.";
    if (form.consent_read_hsq !== "yes") errors.consent_read_hsq = "You must acknowledge reading the HSQ.";
    if (!form.test_to_be_taken) errors.test_to_be_taken = "Please select a test.";
    if (!form.consent_signature) errors.consent_signature = "Consent signature is required.";
    if (!form.consent_printed_name.trim()) errors.consent_printed_name = "Printed name is required.";
    return errors;
  }

  submitForm(e) {
    e.preventDefault();
    const errors = this.validate();
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      toast.error("Please fill in all required fields.");
      return;
    }

    const { doc, form } = this.state;
    if (!doc) return;

    const data = {
      id: doc.id,
      doc_type: doc.docs_type_id,
      form,
      single_doc: true,
    };
    if (this.props.adminMode) data.admin_mode = true;

    this.props.dispatch(docsActions.saveDoc(data)).then((res) => {
      if (res.success) {
        toast.success("HSQ saved successfully.");
        if (this.props.goBack) this.props.goBack();
      } else {
        toast.error(res.message || "An error occurred while saving.");
      }
    });
  }

  renderQuestion(n, text) {
    const fieldKey = `hsq_question${n}`;
    const value = this.state.form[fieldKey];
    const error = this.state.errors[fieldKey];
    return (
      <div className="aplcn-form-row-main" key={n}>
        <div className="row aplcn-row">
          <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
            <p className="aplcn-desc">
              {n}. {text} <span className="required-star">&#x2A;</span>
            </p>
            <ul className="aplcn-checklist inline-radios">
              <li>
                <input
                  type="radio"
                  id={`${fieldKey}_yes`}
                  name={`form.${fieldKey}`}
                  field={`form.${fieldKey}`}
                  value="yes"
                  checked={value === "yes"}
                  onChange={this.handleFormChange}
                />
                <label htmlFor={`${fieldKey}_yes`}>
                  <span className="aplcn-check-label">Yes</span>
                </label>
              </li>
              <li>
                <input
                  type="radio"
                  id={`${fieldKey}_no`}
                  name={`form.${fieldKey}`}
                  field={`form.${fieldKey}`}
                  value="no"
                  checked={value === "no"}
                  onChange={this.handleFormChange}
                />
                <label htmlFor={`${fieldKey}_no`}>
                  <span className="aplcn-check-label">No</span>
                </label>
              </li>
            </ul>
            {error && (
              <div className="aplcn-error-message" style={{ color: "red", marginTop: "5px" }}>
                {error}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { form, errors } = this.state;

    const questions = [
      "During the past 12 months have you at any time (during physical activity or while resting) experienced pain, discomfort or pressure in your chest?",
      "During the past 12 months have you experienced difficulty breathing or shortness of breath, dizziness, fainting, or blackout?",
      "Do you have a blood pressure with systolic (top#) greater than 140 or diastolic (bottom #) greater than 90?",
      "Have you ever been diagnosed or treated for any heart disease, heart murmur, chest pain (angina), palpitations (irregular beat), or heart attack?",
      "Have you ever had heart surgery, angioplasty, or a pace maker, valve replacement, or heart transplant?",
      "Do you have a resting pulse greater than 100 beats per minute?",
      "Do you have any arthritis, back trouble, hip/knee/joint pain or any other bone or joint condition that could be aggravated or made worse by the WCT?",
      "Do you have personal experience or doctor's advice of any other medical or physical reason that would prohibit you from taking the WCT?",
      "Has your personal physician recommended against taking the WCT because of asthma, diabetes, epilepsy, elevated cholesterol or a hernia?",
      "Have you been discharged for any branch of the Armed Forces for issues related to heart problems?",
    ];

    return (
      <div className="hsq-doc-form aplcn-body">
        <div className="aplcn-form aplcn-form-two">
          <form method="post" onSubmit={this.submitForm} noValidate>

            {/* ── Section: HSQ heading ── */}
            <div className="aplcn-form-section-head">
              <h4>HEALTH SCREENING QUESTIONNAIRE (HSQ)</h4>
            </div>

            {/* ── WCFT Level ── */}
            <div className="aplcn-form-row-main aplcn-has-inputs">
              <div className="row aplcn-row">
                <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                  <label className="aplcn-label">
                    WCFT Level <span className="required-star">&#x2A;</span>
                  </label>
                  <ul className="aplcn-checklist inline-radios wcft-level-radios">
                    {[
                      { value: "arduous", label: "Arduous" },
                      { value: "moderate", label: "Moderate", disabled: true },
                      { value: "light", label: "Light", disabled: true },
                    ].map(({ value, label, disabled }) => (
                      <li key={value}>
                        <input
                          type="radio"
                          id={`wcft_level_${value}`}
                          name="form.wcft_level"
                          field="form.wcft_level"
                          value={value}
                          checked={form.wcft_level === value}
                          onChange={this.handleFormChange}
                          disabled={disabled}
                        />
                        <label htmlFor={`wcft_level_${value}`}>
                          <span className="aplcn-check-label">{label}</span>
                        </label>
                      </li>
                    ))}
                  </ul>
                  {errors.wcft_level && (
                    <div className="aplcn-error-message" style={{ color: "red", marginTop: "5px" }}>
                      {errors.wcft_level}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* ── Intro paragraphs ── */}
            <div className="aplcn-form-row-main aplcn-has-inputs">
              <div className="row aplcn-row">
                <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                  <p className="aplcn-desc">
                    Assess your health needs by marking all statements, truthfully. The purpose is to identify individuals
                    who may be at risk in taking the Work Capacity Test (WCT) and recommend an exercise program and/or
                    medical examination prior to taking the WCT.
                  </p>
                  <p className="aplcn-desc">
                    Potential and Returning employees are required to truthfully answer the following questions. The
                    questions were designed, in consultation with occupational health physicians, to ensure you are aware
                    of the strenuous activity in a WCT and to identify individuals who may be at risk when taking a WCT.
                  </p>
                  <p className="aplcn-desc">
                    The HSQ is not a medical examination. Any medical concerns you have that place you or your health at
                    risk should be reviewed with your personal physician prior to participating in the WCT. This is for
                    your safety and wellbeing.
                  </p>
                </div>
              </div>
            </div>

            <div className="aplcn-form-section-head">
              <h5>Check "Yes" or "No" in response to the following questions:</h5>
            </div>

            {/* ── 10 Questions ── */}
            {questions.map((text, i) => this.renderQuestion(i + 1, text))}

            {/* ── Physician note ── */}
            <div className="aplcn-form-row-main aplcn-has-inputs">
              <div className="row aplcn-row">
                <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                  <p className="aplcn-desc">
                    Regardless whether you are taking the Work Capacity Test (WCT) at the <u>Arduous</u>, Moderate or
                    Light duty level, a "Yes" answer requires a determination from your personal physician stating that
                    you are able to participate in the WCT.
                  </p>
                  <p className="aplcn-desc">
                    I understand that if I need to be evaluated by a physician, it will be based on the fitness
                    requirements of the position(s) for which I am qualified.
                  </p>
                </div>
              </div>
            </div>

            {/* ── Applicant Signature ── */}
            <div className="aplcn-form-row-main aplcn-has-inputs">
              <div className="row aplcn-row">
                <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                  <label className="control-label clearfix">
                    APPLICANT SIGNATURE: <span className="required-star">&#x2A;</span>
                  </label>
                </div>
              </div>
              <div className="row aplcn-row aplcn-row--signature" style={{ display: "flex" }}>
                <div
                  className="col-sm-12 col-md-6 aplcn-inp-wrap"
                >
                  <HsqSignaturePad
                    value={form.applicant_signature}
                    error={!!errors.applicant_signature}
                    onSave={(sig) => this.handleSignature("form.applicant_signature", sig)}
                  />
                  {errors.applicant_signature && (
                    <div className="aplcn-error-message">{errors.applicant_signature}</div>
                  )}
                </div>
                <div className="col-sm-12 col-md-6 aplcn-inp-wrap" style={{ paddingLeft: "15px" }}>
                  <label className="control-label clearfix">Date</label>
                  <input
                    type="text"
                    value={form.applicant_date}
                    readOnly
                    disabled
                    className="hsq-date-disabled"
                  />
                </div>
              </div>
              <div className="row aplcn-row">
                <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                  <label className="control-label clearfix">
                    NAME: <span className="required-star">&#x2A;</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Printed Name"
                    value={form.applicant_printed_name}
                    name="form.applicant_printed_name"
                    field="form.applicant_printed_name"
                    onChange={this.handleFormChange}
                    className={errors.applicant_printed_name ? "aplcn-has-error" : ""}
                  />
                  {errors.applicant_printed_name && (
                    <div className="aplcn-error-message" style={{ color: "red", marginTop: "5px" }}>
                      {errors.applicant_printed_name}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* ── WCT Informed Consent ── */}
            <table className="table-light" border="1">
              <thead>
                <tr>
                  <th colSpan={2}>
                    <h2 className="text-center h4"><strong>Work Capacity Test: Informed Consent</strong></h2>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr valign="top">
                  <td width="50%">
                    <ul>
                      <li>
                        <p>
                          <strong>Pack Test-Arduous:</strong> The 3-mile walk with a 45-pound pack or vest completed
                          within 45 minutes is strenuous, but no more so than the duties of wildland firefighting.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Field Test-Moderate:</strong> The 2-mile walk with a 25-pound pack or vest completed
                          within 30 minutes is fairly strenuous, but no more so than the field duties.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Walk Test-Light:</strong> The 1-mile walk completed within 16 minutes is moderately
                          strenuous, but no more so than the duties assigned.
                        </p>
                      </li>
                    </ul>
                  </td>
                  <td width="50%">
                    <p>
                      <strong>Risks:</strong> There is a slight risk of injury (blisters, sore legs, sprained ankles),
                      especially for those not practiced. You should train for several weeks before taking the test.
                      Warm-up and cool-down are recommended. The risk of more serious consequences (respiratory or heart
                      problems) is diminished by completing the HSQ.
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>

            {/* ── Consent checkboxes ── */}
            <div className="aplcn-form-row-main">
              <div className="row aplcn-row">
                <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                  <div className="aplcn-checklist mb-8">
                    <input
                      type="checkbox"
                      id="consent_read_brochure"
                      name="form.consent_read_brochure"
                      field="form.consent_read_brochure"
                      value="yes"
                      checked={form.consent_read_brochure === "yes"}
                      onChange={this.handleFormChange}
                      className="aplcn-visible-check"
                    />
                    <label htmlFor="consent_read_brochure">
                      <span className="aplcn-check-label">
                        I have read the information on this form, the "Work Capacity Test" brochure and understand the
                        purpose, instructions and risks of the job related to work capacity test.{" "}
                        <span className="required-star">&#x2A;</span>
                      </span>
                    </label>
                  </div>
                  {errors.consent_read_brochure && (
                    <div className="aplcn-error-message" style={{ color: "red", marginTop: "5px" }}>
                      {errors.consent_read_brochure}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="aplcn-form-row-main">
              <div className="row aplcn-row">
                <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                  <div className="aplcn-checklist">
                    <input
                      type="checkbox"
                      id="consent_read_hsq"
                      name="form.consent_read_hsq"
                      field="form.consent_read_hsq"
                      value="yes"
                      checked={form.consent_read_hsq === "yes"}
                      onChange={this.handleFormChange}
                      className="aplcn-visible-check"
                    />
                    <label htmlFor="consent_read_hsq">
                      <span className="aplcn-check-label">
                        I have read the information, understood, and truthfully answered the HSQ.{" "}
                        <span className="required-star">&#x2A;</span>
                      </span>
                    </label>
                  </div>
                  {errors.consent_read_hsq && (
                    <div className="aplcn-error-message" style={{ color: "red", marginTop: "5px" }}>
                      {errors.consent_read_hsq}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* ── Test to be taken ── */}
            <div className="aplcn-form-section-head">
              <h5>Test to be taken (check one): <span className="required-star">&#x2A;</span></h5>
            </div>
            <div className="aplcn-form-row-main">
              <ul className="aplcn-checklist test-to-be-taken-checklist">
                {[
                  { value: "arduous_pack_test", label: "Arduous, Pack Test" },
                  { value: "moderate_field_test", label: "Moderate, Field Test" },
                  { value: "light_walk_test", label: "Light, Walk Test" },
                ].map(({ value, label }) => (
                  <li key={value}>
                    <input
                      type="checkbox"
                      id={`test_${value}`}
                      name="testToBeTaken"
                      title="Test to be taken"
                      disabled
                      readOnly
                      checked={form.test_to_be_taken === value}
                    />
                    <label htmlFor={`test_${value}`}>
                      <span className="aplcn-check-label">{label}</span>
                    </label>
                  </li>
                ))}
              </ul>
              {errors.test_to_be_taken && (
                <div className="aplcn-error-message" style={{ color: "red", marginTop: "5px" }}>
                  {errors.test_to_be_taken}
                </div>
              )}
            </div>

            {/* ── Consent Signature ── */}
            <div className="aplcn-form-section-head" />
            <div className="aplcn-form-row-main aplcn-has-inputs">
              <div className="row aplcn-row">
                <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                  <label className="control-label clearfix">
                    SIGNATURE: <span className="required-star">&#x2A;</span>
                  </label>
                </div>
              </div>
              <div className="row aplcn-row aplcn-row--layout">
                <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                  <HsqSignaturePad
                    value={form.consent_signature}
                    error={!!errors.consent_signature}
                    onSave={(sig) => this.handleSignature("form.consent_signature", sig)}
                  />
                  {errors.consent_signature && (
                    <div className="aplcn-error-message">{errors.consent_signature}</div>
                  )}
                </div>
                <div className="col-sm-12 col-md-6 aplcn-inp-wrap" style={{ paddingLeft: "15px" }}>
                  <label className="control-label clearfix">Date</label>
                  <input
                    type="text"
                    value={form.consent_date}
                    readOnly
                    disabled
                    className="hsq-date-disabled"
                  />
                </div>
              </div>
              <div className="row aplcn-row">
                <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                  <label className="control-label clearfix">
                    NAME: <span className="required-star">&#x2A;</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Printed Name"
                    value={form.consent_printed_name}
                    name="form.consent_printed_name"
                    field="form.consent_printed_name"
                    onChange={this.handleFormChange}
                    className={errors.consent_printed_name ? "aplcn-has-error" : ""}
                  />
                  {errors.consent_printed_name && (
                    <div className="aplcn-error-message" style={{ color: "red", marginTop: "5px" }}>
                      {errors.consent_printed_name}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* ── Submit ── */}
            <div className="row">
              <div className="col-sm-12 aplcn-form-main-actionbar">
                <div className="aplcn-form-actionbar">
                  {this.props.goBack && (
                    <button
                      type="button"
                      className="aplcn-prev-button"
                      onClick={(e) => { e.preventDefault(); this.props.goBack(); }}
                    >
                      Back
                    </button>
                  )}
                  <button type="submit" className="aplcn-next-btn">
                    Save
                  </button>
                </div>
              </div>
            </div>

          </form>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { docs, user } = state;
  return { docs, user };
}

const connectedHsq = compose(withRouter, connect(mapStateToProps))(Hsq);
export { connectedHsq as Hsq };
